import React from 'react';
import { Popper } from '@material-ui/core';

const TreezPopper = function (props) {
  return (
    <Popper
      {...props}
      disablePortal={true}
      modifiers={{
        flip: {
          enabled: false,
        },
        preventOverflow: {
          enabled: true,
          boundariesElement: 'scrollParent',
        },
      }}
      placement='bottom'
    />
  );
};

export default TreezPopper;



// WEBPACK FOOTER //
// ./src/components/AdvancedFilter/TreezPopper.jsx